var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { showError, showSuccess } from '@spike/notifications-action';
import axios from 'axios';
import { FORGOT_PASSWORD_ERROR_ACTION_TYPE, FORGOT_PASSWORD_RESET_ACTION_TYPE, FORGOT_PASSWORD_SEND_START_ACTION_TYPE, FORGOT_PASSWORD_SEND_SUCCESS_ACTION_TYPE, FORGOT_PASSWORD_UNKNOWN_EMAIL_ACTION_TYPE, } from './ForgotPasswordActionsTypes';
var url = 'forgot_password';
export var resetThunk = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(reset());
            return [2 /*return*/];
        });
    }); };
};
export var forgotPasswordThunk = function (email, apiClient) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var HTTP_STATUS_422_UNPROCESSABLE_ENTITY, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(start(email));
                    HTTP_STATUS_422_UNPROCESSABLE_ENTITY = 422;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClient.post(url, {
                            email: email.trim().toLowerCase(),
                        })];
                case 2:
                    _a.sent();
                    dispatch(success());
                    dispatch(showSuccess('Reset password notification sent.'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    if (!axios.isCancel(apiError_1)) {
                        if (apiError_1.response && apiError_1.response.status === HTTP_STATUS_422_UNPROCESSABLE_ENTITY) {
                            dispatch(unknownEmail());
                        }
                        else {
                            dispatch(error());
                            dispatch(showError('Error sending forgot password notification.'));
                            console.error(apiError_1);
                        }
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var reset = function () {
    return {
        type: FORGOT_PASSWORD_RESET_ACTION_TYPE,
    };
};
var start = function (email) {
    return {
        type: FORGOT_PASSWORD_SEND_START_ACTION_TYPE,
        payload: {
            email: email,
        },
    };
};
var success = function () {
    return {
        type: FORGOT_PASSWORD_SEND_SUCCESS_ACTION_TYPE,
    };
};
var unknownEmail = function () {
    return {
        type: FORGOT_PASSWORD_UNKNOWN_EMAIL_ACTION_TYPE,
    };
};
var error = function () {
    return {
        type: FORGOT_PASSWORD_ERROR_ACTION_TYPE,
    };
};
